/**
 * Strip markdown formatting and special characters from text.
 * Converts AI-generated text to clean, readable plain text.
 */
export function stripMarkdown(text) {
  if (!text || typeof text !== "string") return text || "";
  return text
    // Remove bold/italic markers
    .replace(/\*\*\*(.*?)\*\*\*/g, "$1")
    .replace(/\*\*(.*?)\*\*/g, "$1")
    .replace(/\*(.*?)\*/g, "$1")
    .replace(/__(.*?)__/g, "$1")
    .replace(/_(.*?)_/g, "$1")
    // Remove headers
    .replace(/^#{1,6}\s+/gm, "")
    // Remove code blocks
    .replace(/```[\s\S]*?```/g, (match) => match.replace(/```\w*\n?/g, "").trim())
    .replace(/`([^`]+)`/g, "$1")
    // Remove links [text](url) -> text
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
    // Remove images ![alt](url)
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1")
    // Remove blockquotes
    .replace(/^>\s+/gm, "")
    // Remove horizontal rules
    .replace(/^[-*_]{3,}\s*$/gm, "")
    // Remove bullet markers but keep text
    .replace(/^[\s]*[-*+]\s+/gm, "- ")
    // Remove numbered list extra formatting
    .replace(/^[\s]*\d+\.\s+/gm, (match) => match.trimStart())
    // Remove HTML tags
    .replace(/<[^>]+>/g, "")
    // Remove escape characters
    .replace(/\\([*_~`#\[\]()>+\-.])/g, "$1")
    // Remove strikethrough
    .replace(/~~(.*?)~~/g, "$1")
    // Clean up multiple newlines
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

/**
 * Strip markdown from all string values in an object (shallow).
 */
export function stripMarkdownObj(obj) {
  if (!obj || typeof obj !== "object") return obj;
  if (Array.isArray(obj)) return obj.map((item) => (typeof item === "string" ? stripMarkdown(item) : stripMarkdownObj(item)));
  const result = {};
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === "string") {
      result[key] = stripMarkdown(value);
    } else if (Array.isArray(value)) {
      result[key] = value.map((item) => (typeof item === "string" ? stripMarkdown(item) : typeof item === "object" ? stripMarkdownObj(item) : item));
    } else if (typeof value === "object" && value !== null) {
      result[key] = stripMarkdownObj(value);
    } else {
      result[key] = value;
    }
  }
  return result;
}
